import type { PropsWithChildren } from 'react'
import { useOutletContext } from 'react-router-dom'

import { WorkAreasDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import WorkAreasDataCollection from 'modules/locations/components/WorkAreasDataCollection'
import { useWorkAreas } from 'modules/locations/hooks/useWorkAreas'

const WorkAreasComponent = ({ children }: PropsWithChildren) => {
  const { locationId } = useOutletContext<{ locationId: string }>()

  const {
    workAreas,
    loading: workAreasLoading,
    error: workAreasError,
  } = useWorkAreas({
    locationIds: [locationId],
  })
  const { data, loading: permissionsLoading, error: permissionsError } = useQuery(WorkAreasDocument)

  const canManageWorkArea = data?.locations._policies.workAreaManage.can ?? false
  const canAddSpace = data?.spaceControl._policies.workSpaceCreate.can ?? false

  const loading = workAreasLoading || permissionsLoading
  const error = workAreasError || permissionsError

  return (
    <ResponsivePage.Body variant="wide" loading={loading} error={error}>
      {children}
      <WorkAreasDataCollection
        workAreas={workAreas}
        locationId={locationId}
        canManageWorkArea={canManageWorkArea}
        canAddSpace={canAddSpace}
      />
    </ResponsivePage.Body>
  )
}

export default WorkAreasComponent
